/** @format */
import PlatformMsisdnPoolNumber from '../../../interfaces/platform/PlatformMsisdnPoolNumber';
import React, { FunctionComponent, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../components/Translate/I18n';
import BackTextButton from '../../../components/Buttons/BackTextButton';
import { msisdnStatus } from '../../../helpers/msisdnStatus';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { numberStateIdMapInt } from '../../lib/search/MsisdnStateHelper';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { MsisdnPoolsChangeStatus } from './MsisdnPoolsChangeStatus';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';

type MsisdnViewType = {
    item: PlatformMsisdnPoolNumber;
    callBack: () => void;
    reload: () => void;
};

export const MsisdnView: FunctionComponent<MsisdnViewType> = ({ item, callBack, reload }): React.ReactElement => {
    const getStatus = (status: number): string => msisdnStatus(status, true);
    const [openChangeStatus, setOpenChangeStatus] = useState(false);

    return (
        <>
            <GridContainer>
                <GridItem xs={2} style={{ padding: 0 }}>
                    <Typography variant="subtitle2" gutterBottom>
                        <I18n trans="simcard:list.status" />
                    </Typography>
                </GridItem>
                <GridItem xs={10} style={{ padding: 0 }}>
                    <Typography variant="subtitle2" gutterBottom>
                        <I18n trans={getStatus(item.numberState)} />
                    </Typography>
                </GridItem>
                <GridItem xs={2} style={{ padding: 0 }}>
                    <Typography variant="subtitle2" gutterBottom>
                        <I18n trans="simcard:list.activation_date" />
                    </Typography>
                </GridItem>
                <GridItem xs={10} style={{ padding: 0 }}>
                    <Typography variant="subtitle2" gutterBottom>
                        {item.activationDate && DateHelperTs.format(item.activationDate)}
                    </Typography>
                </GridItem>
                {/*<GridItem xs={6}>*/}
                {/*    <Typography variant="subtitle2" gutterBottom>*/}
                {/*        <I18n trans="simcard:list.share_date" />*/}
                {/*    </Typography>*/}
                {/*</GridItem>*/}
                {/*<GridItem xs={6}>*/}
                {/*    <Typography variant="subtitle2" gutterBottom>*/}
                {/*        {item.sharedDate && DateHelperTs.format(item.sharedDate)}*/}
                {/*    </Typography>*/}
                {/*</GridItem>*/}
                {/*<GridItem xs={6}>*/}
                {/*    <Typography variant="subtitle2" gutterBottom>*/}
                {/*        <I18n trans="simcard:list.share_end" />*/}
                {/*    </Typography>*/}
                {/*</GridItem>*/}
                {/*<GridItem xs={6}>*/}
                {/*    <Typography variant="subtitle2" gutterBottom>*/}
                {/*        {item.sharedEndDate && DateHelperTs.format(item.sharedEndDate)}*/}
                {/*    </Typography>*/}
                {/*</GridItem>*/}
                {/*    <GridItem xs={6}>*/}
                {/*        <Typography variant="subtitle2" gutterBottom>*/}
                {/*            <I18n trans="simcard:list.portout_date" />*/}
                {/*        </Typography>*/}
                {/*    </GridItem>*/}
                {/*    <GridItem xs={6}>*/}
                {/*        <Typography variant="subtitle2" gutterBottom>*/}
                {/*            {item.portoutDate && DateHelperTs.format(item.portoutDate)}*/}
                {/*        </Typography>*/}
                {/*    </GridItem>*/}
                {/*    <GridItem xs={6}>*/}
                {/*        <Typography variant="subtitle2" gutterBottom>*/}
                {/*            <I18n trans="simcard:list.portin_date" />*/}
                {/*        </Typography>*/}
                {/*    </GridItem>*/}
                {/*    <GridItem xs={6}>*/}
                {/*        <Typography variant="subtitle2" gutterBottom>*/}
                {/*            {item.portinDate && DateHelperTs.format(item.portinDate)}*/}
                {/*        </Typography>*/}
                {/*    </GridItem>*/}
            </GridContainer>
            <BackTextButton callback={callBack} callbackParam={{}} size="sm" />
            {item.numberState === numberStateIdMapInt.LOCK && UserRoleHelper.checkRole(roles.ROLE_PLATFORM_MSISDN_POOL_NUMBER_PUT) && (
                <>
                    <CustomTextButtom
                        callback={(): void => setOpenChangeStatus(true)}
                        callbackParam={{}}
                        color="success"
                        label="pools:msisdn.change_status"
                        size="sm"
                    />
                    <MsisdnPoolsChangeStatus msisdn={item} open={openChangeStatus} reload={reload} close={(): void => setOpenChangeStatus(false)} />
                </>
            )}
        </>
    );
};
